import { useFormik } from 'formik';
import { Dispatch, FC, SetStateAction } from 'react';
import styled from 'styled-components';
import { colors } from '../../../component/colors';
import { ImagePicker } from '../../../component/imagePicker';
import { Input } from '../../../component/input';
import { AddModal } from '../../../component/modal';
import { useAddLifeStyleCategoryMutation } from '../../../store/lifeStyle/api';
import { useAddCategoryMutation } from '../../../store/shopping/api';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { addCategoryValidation } from '../validation';

type IAddCategory = {
  show?: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  currentTab: string;
};
type FormikValues = {
  name: string;
  file: File[] | null;
};
export const AddCategory: FC<IAddCategory> = ({ setShow, currentTab }) => {
  const [addShoppingCategory, { isLoading: isAddShoppingLoading }] =
    useAddCategoryMutation();
  const [addLifestyleCategory, { isLoading: isLifestyleAdding }] =
    useAddLifeStyleCategoryMutation();
  const handleFilePicked = (file: File[]) => {
    setFieldValue('file', file);
  };
  const handleAddCategory = (values: FormikValues) => {
    if (currentTab === 'Shopping') {
      if (!values.file) return showErrorToast('category picture is required');
      const payload = new FormData();
      payload.append('name', values.name);
      values.file.forEach((file) => {
        payload.append('file', file);
      });
      addShoppingCategory(payload)
        .unwrap()
        .then((res) => {
          showSuccessToast(res.message);
          setShow(false);
        })
        .catch((error) => {
          showErrorToast(error.message);
        });
    } else if (currentTab === 'Lifestyle') {
      if (!values.file) return showErrorToast('category picture is required');
      const payload = new FormData();
      payload.append('title', values.name);
      values.file.forEach((file) => {
        payload.append('file', file);
      });
      addLifestyleCategory(payload)
        .unwrap()
        .then((res) => {
          showSuccessToast(res.message);
          setShow(false);
        })
        .catch((error) => {
          showErrorToast(error.message);
        });
    }
  };
  const { values, errors, touched, setFieldValue, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        name: '',
        file: null
      },
      validationSchema: addCategoryValidation,
      onSubmit: handleAddCategory
    });

  return (
    <AddModal
      title={`Add ${currentTab} Category`}
      disableBtn={isAddShoppingLoading || isLifestyleAdding}
      btnTxt={'Add category'}
      btnClick={handleSubmit}
      closeModal={() => setShow(false)}
      isLoading={isAddShoppingLoading || isLifestyleAdding}
    >
      <Container>
        <CustomInput
          labelText={'Category title'}
          value={values.name}
          onChange={handleChange('name')}
          errorMessage={touched.name ? errors.name : ''}
        />

        <CustomImageUpload onFilePicked={handleFilePicked} />
      </Container>
    </AddModal>
  );
};

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0px 40px;
  padding-bottom: 32px;
`;

const CustomInput = styled(Input)`
  flex: 0.46;
  color: ${colors.textDark};
  margin-bottom: 16px;
`;
const CustomImageUpload = styled(ImagePicker)``;
